import * as React from 'react'

import Dashboard from '@material-ui/icons/Dashboard'
import Person    from '@material-ui/icons/Person'

import {
  Account,
  EditEducation,
  EditExperience,
  EditPersonalInformation,
}                                              from '../components/environments'
import App                                     from '../components/environments/App'
import { ExperienceType, Routing, SubRouting } from '../types'
import ProgramRouting                          from './ProgramRouting'

const dashboardRouting: SubRouting = [
  {
    name:      'programs',
    path:      '/programs',
    component: ProgramRouting,
  },
]

const profileRouting: SubRouting = [
  {
    name:      'personal',
    path:      '/personal',
    component: EditPersonalInformation,
  },
  {
    name:      'education',
    path:      '/education',
    component: () => <EditEducation experienceType={ExperienceType.NORMAL} />,
  },
  {
    name:      'experience',
    path:      '/experience',
    component: () => <EditExperience experienceType={ExperienceType.NORMAL} />,
  },
  {
    name:      'account',
    path:      '/account',
    component: Account,
  },
]

const routing: Routing = [
  {
    name:       'dashboard',
    path:       '/dashboard',
    icon:       <Dashboard />,
    subrouting: dashboardRouting,
  },
  {
    name:       'profile',
    path:       '/profile',
    icon:       <Person />,
    subrouting: profileRouting,
  },
]

export default () => <App routing={routing} />



// WEBPACK FOOTER //
// ./src/routing/Coach.tsx